import React, { useEffect, useState } from 'react';
import api from '../api';
import AdCard from './AdCard';
import './AdsGrid.css';

const AdsGrid = ({ dealTypes, title }) => {
    const [ads, setAds] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const params = new URLSearchParams();
        dealTypes?.forEach(t => params.append('dealType', t));

        api.get(`/ads?${params.toString()}`)
            .then(res => setAds(res.data.items ?? []))
            .catch(() => setAds([]))
            .finally(() => setLoading(false));
    }, [dealTypes]);

    return (
        <div className="listings-grid">
            {title && <h2 className="listings-grid__title">{title}</h2>}
            {loading
                ? <div className="listings-grid__loading">Загрузка...</div>
                : ads.length === 0
                    ? <div className="listings-grid__empty">Объявлений пока нет</div>
                    : (
                        <div className="listings-grid__list">
                            {ads.map(ad => (
                                <AdCard
                                    key={ad.id}
                                    ad={ad}
                                    view="grid"
                                    onHidden={(hiddenAd, payload) => {
                                        if (payload.sellerId) {
                                            setAds(prev => prev.filter(a => a.userId !== payload.sellerId));
                                        } else {
                                            setAds(prev => prev.filter(a => a.id !== payload.adId));
                                        }
                                    }}
                                />
                            ))}
                        </div>
                    )
            }
        </div>
    );
};

export default AdsGrid;
